export const FILE_NAME_PREFIX = '温岭EATing创意融合轻食_'

export function buildExportFilename(baseName, ext = 'xlsx') {
  let name = String(baseName || '导出').trim()
  if (name.startsWith(FILE_NAME_PREFIX)) {
    name = name.slice(FILE_NAME_PREFIX.length)
  }
  name = name.replace(/\.(xlsx|xls|csv)$/i, '')
  const cleanExt = String(ext || 'xlsx').replace(/^\./, '')
  return `${FILE_NAME_PREFIX}${name}.${cleanExt}`
}

export function triggerBlobDownload(blob, baseName, ext = 'xlsx') {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = buildExportFilename(baseName, ext)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export function parseContentDispositionFilename(header, fallbackBase, ext = 'xlsx') {
  let name = fallbackBase
  if (header) {
    const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(header)
    if (utf8Match) {
      try {
        name = decodeURIComponent(utf8Match[1])
      } catch (e) {
        name = utf8Match[1]
      }
    } else {
      const plainMatch = /filename="?([^";]+)"?/i.exec(header)
      if (plainMatch) name = plainMatch[1]
    }
  }
  const matchedExt = String(name).match(/\.([^.]+)$/i)
  const resolvedExt = matchedExt ? matchedExt[1] : ext
  const base = String(name).replace(/\.[^.]+$/, '')
  return buildExportFilename(base, resolvedExt)
}

function extFromFilename(name, fallback) {
  const matched = String(name || '').match(/\.([^.]+)$/i)
  return matched ? matched[1] : fallback
}

export function downloadBlobResponse(response, fallbackBase, ext = 'xlsx') {
  const cd = response.headers && (response.headers['content-disposition'] || response.headers['Content-Disposition'])
  const filename = parseContentDispositionFilename(cd, fallbackBase, ext)
  triggerBlobDownload(
    response.data,
    filename.replace(/\.[^.]+$/, ''),
    extFromFilename(filename, ext)
  )
}
